import React, { useCallback, useEffect, useRef, useState } from 'react';
import { fetchClassroomBalloon } from './wheelApi';
import LearnedLettersDialog from './LearnedLettersDialog';
import ClassroomTrain from '../sound-hunt/ClassroomTrain';
import ClassroomLaunchScreen from './ClassroomLaunchScreen';
import { prepareClassroomTrainBackdrop } from './prepareClassroomTrainBackdrop';

export default function ClassroomTrainActivity({ token, onClose }) {
  const [data, setData] = useState(null), [pending, setPending] = useState(null);
  const [settings, setSettings] = useState(false), [refreshing, setRefreshing] = useState(false), [error, setError] = useState('');
  const live = useRef(false);
  const load = useCallback(async () => {
    setError(''); setRefreshing(true);
    try {
      // Preserve the existing target on settings refresh, and decode decorative
      // artwork only on first opening. Both screens always paint the same URL.
      const firstLoad = !data;
      const [result] = await Promise.all([
        fetchClassroomBalloon(token),
        firstLoad ? prepareClassroomTrainBackdrop() : Promise.resolve(),
      ]);
      if (live.current) { if (data) setPending(result); else setData(result); setSettings(false); }
    } catch (err) { if (live.current) { setSettings(false); setError(err.message); } }
    finally { if (live.current) setRefreshing(false); }
  }, [token, data]);
  useEffect(() => {
    live.current = true;
    load();
    return () => { live.current = false; };
    // Initial fetch only; later refreshes preserve the current teacher target.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  return <>
    {data && <ClassroomTrain data={data} pendingData={pending} paused={settings || refreshing || Boolean(error)} onSettings={() => setSettings(true)} onClose={onClose} />}
    {(!data || error) && !settings && <ClassroomLaunchScreen game="train"
      error={error} onRetry={load} busy={refreshing} onClose={onClose} />}
    {settings && <LearnedLettersDialog token={token} onSaved={load} onCancel={() => setSettings(false)} />}
  </>;
}
